import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TieredMenu, TieredMenuModule } from 'primeng/tieredmenu';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { SpanTooltipComponent } from '../span-tooltip/span-tooltip.component';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { Tooltip, TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'button-with-menu-action',
    templateUrl: './button-with-menu-action.component.html',
    standalone: true,
    imports: [
      TieredMenuModule,
      AfTranslatePipe,
      SpanTooltipComponent,
      TooltipModule
    ]
})
export class ButtonWithMenuActionComponent implements AfterViewInit {
  type: string = ''

  constructor( private commonUtilsService: CommonUtilsService ) { }
  @Input() item : any = {};
  @Input() multiline : number = 2;
  @Input() icon : string = 'lf-icon-kebab-menu-scale100';
  @Input() buttonClass : string = 'common-button__icon-md-noborder';
  @Input() disabled : boolean = false;
  @Input() disabledClick : boolean = false;
  @Input() disabledTooltip: boolean = true;
  @Input() tooltipText: string = '';
  @Input() tooltipPosition: string = 'top';
  @Input() buttonOptionClass: string = 'common-dropdown-list__si-button';
  @Output() launchActionEmitter = new EventEmitter();
  @Output() configureMenuEmitter = new EventEmitter();
  @ViewChild('tieredMenuActionSelected') tieredMenuActionSelected: TieredMenu;
  @ViewChild(Tooltip) tooltip: Tooltip;

  ngAfterViewInit(): void {
    this.commonUtilsService.bindScrollOverlayListener(this.tieredMenuActionSelected, 'menu');
    this.type = this.item.keyName?  this.item.keyName : 'name'
  }

  launchAction(action:any, optionAction:any){
    this.launchActionEmitter.emit({action: action, option: optionAction, tooltip: this.tooltip});
  }

  configureMenu(){
    let that = this;
    this.configureMenuEmitter.emit();
    setTimeout(()=>{
      that.tieredMenuActionSelected.alignOverlay();
      let containerTieredMenu: any = that.tieredMenuActionSelected.container;
      let className: any = containerTieredMenu.className;
      containerTieredMenu.className = className + ' common-dropdown-list__a-container-visibility--visible';
    })
  }

  toggleFilter(e: any){
    if(!this.disabledClick){
      this.commonUtilsService.toggleFilterOverlay(e, this.tieredMenuActionSelected, 'menu');
    }
  }
}
